import { Type } from 'class-transformer';

import { IPagination, IQueryPaginationDto } from '@/types/utils';

export class CallForwarding {
  id: string;
  name: string;
  createdAt: Date;
  company: string;
  title: string;
  type: string;
  unit: string;
  description: string;
  recallCounter?: number;
  recallAgainReason?: string;
  updatedAt: Date;
  creatorUser: string;
  bolge_point_id?: number;
  bolge_name?: string;
}

export class ICallForwardingResponse {
  @Type(() => CallForwarding)
  result: CallForwarding;
}

export class ICallForwardingListResponse extends IPagination {
  @Type(() => CallForwarding)
  results: CallForwarding[];
}

export class ICallForwardingQueryDto extends IQueryPaginationDto {
  name?: string;
  type?: string;
  unit?: string;
  title?: string;
  dateCreatedStart?: string;
  dateCreatedEnd?: string;
}

export class IPostCallForwardingBodyDto {
  name: string;
  company: string;
  title: string;
  type: string;
  unit: string;
  description: string;
  recallCounter?: number;
  recallAgainReason?: string;
  bolge_point_id: number;
}

export class IPatchCallForwardingBodyDto {
  name?: string;
  company?: string;
  title?: string;
  type?: string;
  unit?: string;
  description?: string;
  recallCounter?: number;
  recallAgainReason?: string;
  bolge_point_id?: number;
}
